/**
 * Brochure opt-in marketing text toggle.
 *
 * Handles the "Toon meer" / "Toon minder" toggle for the opt-in marketing
 * text that appears below a Gravity Forms field in the brochure panel.
 */
document.addEventListener( 'DOMContentLoaded', () => {
	document.addEventListener( 'click', ( event ) => {
		const toggle = event.target.closest( '.brochure-optin-toggle' );
		if ( ! toggle ) {
			return;
		}

		const wrapper = toggle.closest( '.brochure-optin-wrapper' );
		if ( ! wrapper ) {
			return;
		}

		const content = wrapper.querySelector( '.brochure-optin-content' );
		if ( ! content ) {
			return;
		}

		const isHidden = content.style.display === 'none';
		content.style.display = isHidden ? 'block' : 'none';
		toggle.textContent = isHidden ? 'Verbergen' : 'Toon meer';
		toggle.setAttribute( 'aria-expanded', isHidden ? 'true' : 'false' );
	} );

	// Hide image and intro after successful Gravity Forms submission.
	if ( window.jQuery ) {
		jQuery( document ).on( 'gform_confirmation_loaded', function( event, formId ) {
			const dialog = document.querySelector( '.brochure-panel-dialog[open]' );
			if ( ! dialog ) {
				return;
			}

			const text = dialog.querySelector( '.brochure-panel__text' );
			const form = dialog.querySelector( '.brochure-panel__form' );

			if ( text ) {
				text.style.display = 'none';
			}
			if ( form ) {
				form.classList.add( 'brochure-panel__form--success' );

				const closeBtn = document.createElement( 'button' );
				closeBtn.type = 'button';
				closeBtn.className = 'button--primary';
				closeBtn.textContent = 'Venster sluiten';
				closeBtn.addEventListener( 'click', function() {
					dialog.close();
				} );
				form.appendChild( closeBtn );
			}
		} );
	}
} );
